import { IState } from 'shared/store';

export const selectEstimationExist = (state: IState) => {
  return state.valuationTraps.isEstimationExist;
};
